<div class="flex flex-col items-center justify-center min-h-screen bg-gray-50 dark:bg-gray-900 p-4">
  <div class="max-w-md w-full bg-white dark:bg-gray-800 rounded-lg shadow-lg p-8 text-center">
    <!-- Ikona błędu -->
    <div class="mb-6">
      <i class="pi pi-ban text-6xl text-red-500"></i>
    </div>
    
    <!-- Tytuł -->
    <h1 class="text-2xl font-bold text-gray-900 dark:text-white mb-4">
      {{ getTitle() }}
    </h1>
    
    <!-- Główna wiadomość -->
    <p class="text-gray-600 dark:text-gray-300 mb-4">
      {{ getMessage() }}
    </p>
    
    <!-- Opis -->
    <p class="text-sm text-gray-500 dark:text-gray-400 mb-6">
      {{ getDescription() }}
    </p>
    
    
    <!-- Przycisk wylogowania -->
    <p-button 
      [label]="getLogoutButtonText()" 
      icon="pi pi-sign-out" 
      severity="primary"
      (onClick)="logout()"
      class="w-full">
    </p-button>
  </div>
</div>
